/**
 * Append a stylesheet to the dom if it is not already there
 *
 * @param url - The url to load styles from
 */
export function appendStylesheet(url: string): void {
  // Return if the stylesheet is already appended
  const element = document.getElementById(url);
  if (element) {
    return;
  }

  const link = document.createElement('link');
  link.type = 'text/css';
  link.rel = 'stylesheet';
  link.id = url;
  link.href = url;

  document.head.appendChild(link);
}
